import React, { useEffect, useState } from 'react';
import './realEstate.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import insetBuilding from '../../assets/realestate-top-inset.png';
import constructionBackground from '../../assets/realestate-newsletter-bg.png';
import { sendContactEmail } from '../../utils/emailjs';

const RealEstate = () => {
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Real Estate Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__realestate-page">
      <section className="kw__realestate-hero kw__realestate-section">
        <p className="kw__realestate-outline">Real Estate &amp; Construction</p>
        <h1 className="kw__realestate-title">Asset-Oriented Property Development</h1>
        <p className="kw__realestate-copy">
          We shape developments that begin with land and end as functional, value-driven assets. Every layer of construction is aligned to ensure
          strength, usability, and permanence across structural build, material application, and final completion.
        </p>
      </section>

      <section className="kw__realestate-inset-wrap" aria-hidden="true">
        <img src={insetBuilding} alt="" className="kw__realestate-inset" />
      </section>

      <section className="kw__realestate-blackband">
        <div className="kw__realestate-section kw__realestate-blackband-inner">
          <h2>Structure That Survives Every Build Phase</h2>
          <p>
            Real estate and construction are not just about plans they are about how consistently those plans are executed under real-world
            conditions.
          </p>
          <p>
            Our focus is on disciplined execution at every stage from foundation work to final completion ensuring stability, coordination, and
            structural clarity under pressure.
          </p>
          <p>
            This is for developers, investors, and partners who understand that scale only works when execution holds firm on-site, not just in
            planning.
          </p>
          <p>If the goal is to build with control, clarity, and real structural reliability, let&apos;s discuss your project.</p>

          <button type="button" className="kw__realestate-discuss-btn">
            <span>Let&apos;s Discuss Your Project</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>
      </section>

      <section className="kw__realestate-news-area">
        <div className="kw__realestate-section kw__realestate-news-inner">
          <div className="kw__realestate-realtime">
            <h2>Real-Time Construction Adjustments</h2>
            <p>
              We remain closely involved throughout the build phase, where conditions can change constantly. Ground conditions, material response,
              and structural alignment influence every step. Each shift is managed to ensure continuity between concept and finished form without
              weakening durability or spatial coherence.
            </p>
          </div>

          <div className="kw__realestate-newsletter">
            <p className="kw__realestate-newsletter-label">Newsletter</p>
            <h3>Never Miss an Update</h3>
            <p className="kw__realestate-newsletter-copy">
              Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
              your inbox.
            </p>

            <form className="kw__realestate-newsletter-form" onSubmit={handleSubmit}>
              <div className="kw__realestate-newsletter-row">
                <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
                <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
              </div>
              <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
              <button type="submit" className="kw__realestate-submit-btn">
                <span>Submit</span>
                <img src={buttonArrow} alt="" />
              </button>
            </form>
          </div>
        </div>

        <img src={constructionBackground} alt="" className="kw__realestate-news-bg" aria-hidden="true" />
      </section>
    </div>
  );
};

export default RealEstate;
